import {Modal, ModalButtons} from 'shared/components/modals';
import {FormattedMessage} from 'react-intl';

const ArchiveDimensionValueModal = ({uiState, modalOpen}) => {
  return (
    <Modal
      title='time_tracking.dimensions.archive.Archive Value'
      size='sm'
      isOpen={modalOpen}
      onHide={() => uiState.closeArchiveDimensionValueModal()}
    >
      <div className='mb3 jumbo'>
        <FormattedMessage id={'time_tracking.dimensions.archive.DESCRIPTION'}/>
      </div>
      <ModalButtons
        saveCaption='time_tracking.dimensions.archive.Archive'
        onSave={() => uiState.archiveDimensionValue()}
        onCancel={() => uiState.closeArchiveDimensionValueModal()}/>
    </Modal>
  );
};

export default ArchiveDimensionValueModal;
